// Work-type colors come from the enum as argb ("FF4472C4") or rgb ("4472c4").
export const toHex = (argb, fallback = '#98A2B3') => {
  if (!argb || typeof argb !== 'string') return fallback;
  return `#${argb.length === 8 ? argb.slice(2) : argb}`;
};
